module.exports = __webpack_public_path__ + "static/media/logo535.3972ab59.png";